<template>
    <paper>
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @edit-btn="handleEdit"
            @editRecord-btn="viewEditRecord"
            searchId="driverPaymentDurationConfigQuery"
            pageID="driverPaymentDurationConfig"
        >
            <span slot="search-list-advance-right">
                <el-button @click="handleReset" type="primary" class="reset-btn">重 置</el-button>
            </span>
            <div slot="table-module-btn">
                <el-tooltip
                    class="item"
                    effect="dark"
                    content="新增配置"
                    placement="bottom"
                >
                    <el-button
                        v-has="'driver-payment-duration-config-add'"
                        size="mini"
                        icon="el-icon-plus"
                        @click="handleAddData"
                    ></el-button>
                </el-tooltip>
                <reportExport
                    #default="{ submit }"
                    reportCode="PAYMENT_DURATION_CONFIG_EXPORT"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span style="margin-left: 10px;">
                            <el-button
                                v-has="'driver-payment-duration-config-export'"
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button
                    v-has="'driver-payment-duration-config-enable'"
                    type="primary"
                    :disabled="!this.selected.length"
                    @click="handleEnable"
                    >启用</el-button
                >
                <el-button
                    v-has="'driver-payment-duration-config-disable'"
                    type="primary"
                    :disabled="!this.selected.length"
                    @click="handleDisable"
                    >停用</el-button
                >
                <el-button
                    v-has="'driver-payment-duration-config-delete'"
                    type="primary"
                    :disabled="!this.selected.length"
                    @click="handleDelete"
                    >删除</el-button
                >
            </div>
        </m-pane>
        <!-- 编辑记录 -->
        <edit-record-dialog
            v-if="editRecordDialogShow"
            :editRecordDialogShow.sync="editRecordDialogShow"
            :componentsData="rowData"
            :dictData="dictData"
            @refresh="refresh"
        ></edit-record-dialog>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/otpPanel';
import config from './config.js';
import { mapState } from 'vuex';
import { dictWithUrl } from '@/components/lots/api.js';
import { formatSearchData, formatTotalDataList, messageTips } from './util';
import { queryPage, queryCount, updateConfigFlag, handleDelete } from '../../../api/driverPaymentDurationConfig.js';
import reportExport from '@/components/lots/reportExportPlugin';
import EditRecordDialog from './components/EditRecord';
export default {
    name: 'DriverPaymentDurationConfig',
    components: {
        paper,
        mPane,
        reportExport,
        EditRecordDialog
    },
    data () {
        return {
            config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            isFirstSearch: true,
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                param: {}
            },
            rowData: {},
            selected: [],
            editRecordDialogShow: false,
            dictData: {}
        };
    },
    computed: {
        ...mapState({
            user: state => state.user,
            currentTenant: state => state.currentTenant,
            supplier: state => state.supplier
        })
    },
    mounted () {
        this.getDicData();
    },
    methods: {
        async getDicData () {
            const dict = await dictWithUrl(
                // eslint-disable-next-line max-len
                'OTP_APPLY_STATUS'
            );
            this.dictData = dict.data;
        },
        /**
         * @description 查询条件变化触发事件
         * @param {Object} data 查询条件
         */
        searchChange (data) {
            // 格式化查询条件
            const _searchData = formatSearchData(data);
            this.searchParams = this.getSearchData(_searchData);
            this.getList();
        },
        /**
         * @description 获取列表数据
         * @param {object} 查询条件
         * @return {list} 列表数据
         */
        getList () {
            this.loading = true;
            this.queryCount();
            queryPage(this.searchParams)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.totalData = formatTotalDataList(res.data.list || [], this.dictData);
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                    this.isFirstSearch = false;
                });
        },
        getSearchData (data) {
            const _searchData = {
                ...this.searchParams,
                pageNo: 1,
                param: {
                    ...data,
                    carrierCode: this.supplier.supplierCode // 供应商编码-LSP
                }
            };
            return _searchData;
        },
        queryCount () {
            queryCount(this.searchParams.param)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.pageTotal = res.data || 0;
                    }
                })
                .catch(() => { });
        },
        // 重置查询参数
        handleReset () {
            this.$refs.tablePage.$refs.searchList.dataInit(null, true);
        },
        /**
         * @description 导出
        */
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                ...this.searchParams.param,
                siteCodeList: this.siteCodeList,
                tenantCode: this.currentTenant.tenantCode,
                beginDate: '2010-07-26 00:00:00', // 没有的字段，为了后端导出任务片段必填
                endDate: '2030-07-26 00:00:00'
            });
            this.isFirstSearch = false;
        },
        handleAddData () {
            this.$router.push({
                path: '/otp/transport-center/payment-duration-detail',
                query: {
                    type: 'add'
                }
            });
        },
        handleEdit (rowData) {
            if (rowData.id) {
                this.$router.push({
                    path: '/otp/transport-center/payment-duration-detail',
                    query: {
                        id: rowData.id,
                        type: 'edit'
                    }
                });
            }
        },
        viewEditRecord (rowData) {
            this.rowData = rowData;
            this.editRecordDialogShow = true;
        },
        handleEnable () {
            if (this.selected.length !== 1) {
                return this.$message.warning('不可选中多条数据操作，请重新选择');
            }
            if (this.selected[0].iflowStatus && this.selected[0].iflowStatus !== 'P') {
                return this.$message.warning('该配置正在审批中或审批不通过，启用失败，审批通过才可启用');
            }
            updateConfigFlag({ id: this.selected[0].id, configFlag: true })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.warning('操作成功');
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.getList();
                });
        },
        handleDisable () {
            if (this.selected.length !== 1) {
                return this.$message.warning('不可选中多条数据操作，请重新选择');
            }
            updateConfigFlag({ id: this.selected[0].id, configFlag: false })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.warning('操作成功');
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.getList();
                });
        },
        handleDelete () {
            if (this.selected.length !== 1) {
                return this.$message.warning('不可选中多条数据操作，请重新选择');
            }
            messageTips('确定删除该配置？', handleDelete, { id: this.selected[0].id }, '操作成功', this);
        },
        // 刷新页面
        refresh (dialogVisible) {
            this[dialogVisible] = false;
            this.getList();
        },
        // 选中表格行
        selectChange (data) {
            this.selected = data;
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getList();
        },
        // 切换分页显示条数
        sizeChange (pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.getList();
        }
    }
};
</script>

<style scoped>
.reset-btn {
    margin-left: 10px;
}
</style>
